<div mat-dialog-title style="margin:0px;">{{PageTitle}}</div> 

    
    <mat-dialog-content>
        <div style="padding: 10px;">
                {{Message}}
        </div>

        <table *ngIf="viewDependentTests" class="table" style="width:100%;">

            <tr>
                <td>Module Name</td>
                <td>Portal Name</td>
                <td>Test Name</td>
                <td>Step</td>
            </tr>
            <tr *ngFor="let test of dependentTests" style="border-top: 1px solid silver;">
                <td style="width:250px;">
                    {{test.AreaName}}
                </td>
                <td style="width:250px;">
                    {{test.SubAreaName}}
                </td>
                <td style="width:250px;">
                    {{test.TestName}}
                </td>
                <td style="width:25px;">
                    #{{test.StepOrder}}
                </td>
            </tr>
        </table>

        <table *ngIf="showTestSteps" style="width:50%; padding-top:20px; padding-bottom:20px;">
            <th>Parameters</th>
            <tr *ngFor="let param of parameters" style="border-top: 1px solid silver;">
                <td>{{param.ParameterName}}</td>
                <td>{{param.ParameterValue}}</td>
            </tr>
        </table>
        <br />&nbsp;
        <table *ngIf="showTestSteps"  style="width:100%; padding-top:20px;">
            <th>Steps</th>
            <tr>
                <td></td>
                <!-- <td>&nbsp;&nbsp;&nbsp;Module</td>
                <td>Portal</td> -->
                <td>Shared Test</td>
                <td>Page</td>
                <td>Tab/View</td>
                <td>Element Name</td>
                <td>Control</td>
                <td>Action</td>
                <td>Data Input</td>
                <td>Step Comments</td>
            </tr>
            <tr *ngFor="let step of testSteps" style="border-top: 1px solid silver;">
                <td style="width:50px;">
                    #{{step.StepOrder}}
                </td>
                <!-- <td style="width:250px;">
                    #{{step.StepOrder}} {{step.TestAreaName}}
                </td>
                <td style="width:200px;">
                    {{step.TestSubAreaName}}
                </td> -->
                <td style="width:250px;">
                    {{step.TestName}}<!-- <span *ngIf="step.TestComments != null"><br /><a (click)="showComments(step.TestComments)">Comments</a></span> -->
                </td>
                <td style="width:200px;">
                    {{step.ElementAreaName}}
                </td>
                <td style="width:200px;">
                    {{step.ElementSubAreaName}}
                </td>
                <td style="width:200px;">
                    {{step.ElementName}} <!-- <span *ngIf="step.StepComments != null"><a (click)="showComments(step.StepComments)">Comments</a></span> -->
                </td>
                <td style="width:150px;">
                    {{step.ControlName}}
                </td>
                <td style="width:200px;">
                    {{step.ActionName}}<br />
                </td>
                <td style="width:200px;">
                    {{step.ParameterValue}}
                </td>
                <td style="width:300px;">
                    {{step.StepComments}}
                </td>
                <!-- <table>
                    <tr>
                        <td colspan="3">
                            {{step.TestComments}}
                        </td> 
                        <td colspan="6">
                            {{step.StepComments}}
                        </td> 
                    </tr>
                </table> -->

            </tr>
        </table>

    </mat-dialog-content>
    
    <mat-dialog-actions>
        <div class="flex-footer-right">
            <!-- <tyl-button id="okButton" image="next arrow.png" label="Continue" (clickEvent)="okClick()"></tyl-button> -->
            <tyl-button id="cancelButton" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
        </div>
    </mat-dialog-actions>